/* Combine all available reducers to a single root reducer.
 *
 * CAUTION: When using the generators, this file is modified in some places.
 *          This is done via AST traversal - Some of your formatting may be lost
 *          in the process - no functionality should be broken though.
 *          This modifications only run once when the generator is invoked - if
 *          you edit them, they are not updated again.
 */
/* Populated by react-webpack-redux:reducer */
import {combineReducers} from 'redux';
import test              from '../reducers/test.js';
import notif             from '../reducers/Notifications.js';
import login             from '../reducers/Login.js';
import navigation        from '../reducers/Navigation.js';
import auditTrail        from '../reducers/AuditTrail.js';
import usersetup         from '../reducers/UserSetup.js';
import accessjson        from '../reducers/accessJSON.js';
import vip_notif         from '../reducers/NotificationVIP.js';
import redemptionsummary from '../reducers/RedemptionSummary.js';
import generatepromocode from '../reducers/GeneratePromocode.js';
import segmentedPush     from '../reducers/SegmentedPush.js';
import EVoucher          from '../reducers/EVoucher.js';
import EVScanner         from '../reducers/EVScanner.js';
import MemberToken       from "./MemberToken.js";
import Reports           from "./Reports";
import EVoucherUpdateLogs from "./EVoucherUpdateLogs" ;
import PendingNotification from "./PendingNotification";
import NotificationHistory from "./NotificationHistory";
import ScheduledNotification from "./ScheduledNotification";
import CampaignCategory   from "./CampaignCategory";
import CustomBlockMessage from "./CustomBlockMessage";
import MobilePOSScanLog from "./MobilePOSScanLog";
import TierBlockMessage from "./TierBlockMessage";
import Beacon from "./Beacon";
import EVoucherCardType from "./EVoucherCardType";
import EVoucherPromoCategory from "./EVoucherPromoCategory";
import AppMenu from "./AppMenu";
import CardImages from "./CardImages";
import Kumulos from "./Kumulos";
import MkioskBanner from "./MkioskBanner";
import LifestyleBanner from "./LifestyleBanner";
import PointsBanner from "./PointsBanner";
import SignUpConfig from "./SignUpConfig";
import AppConfig from "./AppConfig";
import EWallet from "./EWallet";
import PhoenixVoucher from "./PhoenixVoucher";
import AppThumb from "./AppThumb";

const reducers = {
	test,
	notif,
	login,
	navigation,
	auditTrail,
	usersetup,
	accessjson,
	vip_notif,
	redemptionsummary,
	generatepromocode,
	segmentedPush,
	EVoucher,
	EVScanner,
	MemberToken,
	Reports,
	EVoucherUpdateLogs,
	PendingNotification,
	NotificationHistory,
	ScheduledNotification,
	CampaignCategory,
	CustomBlockMessage,
	MobilePOSScanLog,
	TierBlockMessage,
	Beacon,
	EVoucherCardType,
	EVoucherPromoCategory,
	AppMenu,
	CardImages,
	Kumulos,
	MkioskBanner,
	LifestyleBanner,
	PointsBanner,
	SignUpConfig,
	AppConfig,
	EWallet,
	PhoenixVoucher,
	AppThumb
};

const combined = combineReducers(reducers);
module.exports = combined;



// WEBPACK FOOTER //
// ./reducers/index.js